import React from 'react';

import { musicFieldDecorator } from 'components/dashboard/music-links-content/decorators';
import InputField from 'components/elements/InputField';

const MusicFieldName = (props) => {
  return (
    <InputField
      {...props}
      hoverable
    />
  );
};

export default musicFieldDecorator(MusicFieldName);
